import { createServerClient, type CookieOptions } from '@supabase/ssr';
import { NextResponse, type NextRequest } from 'next/server';

import { AUTH_SESSION_MAX_AGE_SECONDS, getSupabaseClientEnv, type SupabaseAppTarget } from '../config';

export const createSupabaseMiddlewareClient = (
  request: NextRequest,
  app?: SupabaseAppTarget,
) => {
  const env = getSupabaseClientEnv(app);
  let response = NextResponse.next({ request });

  const supabase = createServerClient(env.supabaseUrl, env.supabaseAnonKey, {
    cookies: {
      getAll() {
        return request.cookies.getAll();
      },
        setAll(cookies: { name: string; value: string; options?: CookieOptions }[]) {
          cookies.forEach(({ name, value }) => {
            request.cookies.set(name, value);
          });
          response = NextResponse.next({ request });
          cookies.forEach(({ name, value, options }) => {
            response.cookies.set(name, value, options);
          });
        },
      },
    cookieOptions: {
      path: '/',
      sameSite: 'lax',
      maxAge: AUTH_SESSION_MAX_AGE_SECONDS,
    },
  });

  const getResponse = () => response;

  return { supabase, getResponse };
};
